import "./insHeatMap.scss";
import Highcharts from "highcharts/highstock";
import heatMapModule from "highcharts/modules/heatmap";
import React from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { numberFormatters } from "common";
import { NumberFormatKind } from "common/types";
import { InsHighcharts } from "components/widgets/base";
import { InsLabelValueTooltip } from "components/widgets/base/common/insLabelValueTooltip";
import { InsQueryStatedElement } from "components/widgets/base/insQueryStatedElement";
import { useGetDatapointsWidgetData } from "hooks/widget-data/use-datapoints";
heatMapModule(Highcharts);
export const InsHeatMap = (props) => {
    const [[data], queryState] = useGetDatapointsWidgetData(props);
    const xColumns = data?.data[0]?.xColumns ?? data?.data[0]?.columns ?? [];
    const yColumns = data?.data[0]?.yColumns ?? data?.data[0]?.columns ?? [];
    const options = {
        chart: {
            animation: true,
            className: "insHeatMap",
            marginBottom: 80,
            styledMode: true,
            type: "heatmap"
        },
        colorAxis: {
            labels: {
                enabled: true,
                formatter() {
                    return numberFormatters(this.value, NumberFormatKind.percent, { maximumFractionDigits: 2 });
                },
                step: 1,
                useHTML: true
            },
            max: data?.additionalData?.max,
            min: data?.additionalData?.min,
            // eslint-disable-next-line no-magic-numbers
            stops: [[0, "#055080"], [0.5, "#0998F6"], [1, "#CDEAFE"]]
        },
        colors: [],
        credits: { enabled: false },
        legend: {
            layout: "horizontal",
            x: 60,
            y: 20
        },
        plotOptions: {
            column: { animation: false, stacking: "normal", stickyTracking: false, zIndex: 1 },
            scatter: { zIndex: 2 }
        },
        series: [
            {
                data: data?.data?.[0]?.matrixValues,
                dataLabels: {
                    enabled: true,
                    formatter() {
                        // Not showing bright label on bright backgrounds and vice versa
                        const { point } = this;
                        const { color } = point;
                        const colorString = color?.toString() ?? "";
                        const colorValues = colorString.substring(4, colorString.length - 1)
                            .replace(/ /gu, "")
                            .split(",")
                            .map((x) => parseInt(x, 10));
                        const [r, g, b] = colorValues;
                        // eslint-disable-next-line no-magic-numbers
                        const brightness = ((r * 299) + (g * 587) + (b * 114)) / 1000;
                        // eslint-disable-next-line no-magic-numbers
                        return renderToStaticMarkup(React.createElement("span", { className: "series-data-labels", style: { color: brightness < 128 ? "#FFFFFF" : "#000000" } }, this.point?.options?.custom?.formattedValue || this.point?.options?.value));
                    },
                    useHTML: true
                },
                type: "heatmap"
            }
        ],
        title: {
            text: ""
        },
        tooltip: {
            formatter() {
                return renderToStaticMarkup(React.createElement(InsLabelValueTooltip, { labelValuePairs: this.point?.options?.custom?.tooltip || [] }));
            },
            useHTML: true
        },
        xAxis: {
            categories: xColumns.map((y) => y.label),
            className: "highcharts-xaxis-labels"
        },
        yAxis: {
            categories: yColumns.map((y) => y.label),
            className: "highcharts-yaxis-labels",
            reversed: true,
            title: {
                text: ""
            }
        }
    };
    return (React.createElement(InsQueryStatedElement, { widgetFactoryProps: props, queryState: queryState, hasData: data?.data?.[0]?.matrixValues.length >= 0 },
        React.createElement(InsHighcharts, { options: options, ...props })));
};
